<template>
  <b-modal id="funcionarios-modal" title="Lista de Equipamentos Autorizados" hide-footer @hide="handleModalClose">
    <button v-if="isSuperAdmin" class="actionBtn addBtn" @click="goToEquipmentsPage">Adicionar equipamento</button>
    <ul class="list">
      <li v-if="equipments.length === 0">Nenhum equipamento disponível.</li>
      <li class="list-item" v-else v-for="equipment in equipments" :key="equipment.id">
        {{ equipment.name }}
        <span v-if="!isReadOnly" title="Remover equipamento" @click="confirmRemove(equipment)"><b-icon icon="trash" class="icon-remove"></b-icon></span>
      </li>
    </ul>
    <template v-if="!isReadOnly && equipmentToRemove">
      <p class="message">Confirma a remoção do equipamento "{{ equipmentToRemove.name }}"?</p>
      <form @submit.prevent="removeEquipment" class="form">
        <button class="actionBtn">Confirmar</button>
        <button class="cancelBtn" type="button" @click="equipmentToRemove = null">Cancelar</button>
      </form>
    </template>
  </b-modal>
</template>

<style scoped>
.addBtn {
  display: block;
  margin: 0 0 16px auto;
}

.list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 16px;
  padding: 16px;
  background-color: #fff;
  border-radius: 8px;
  list-style: none;
}

.list-item {
  color: #000;
  padding: 10px 20px;
  border: 1px solid #557c56;
  border-radius: 16px;
  display: flex;
  column-gap: 16px;
  align-items: center;
  box-shadow: 2px 2px 3px #3a3a3a70;
}

.list-item:hover {
  border-color: #99b099;
}

.icon-remove {
  cursor: pointer;
}

.icon-remove:hover {
  color: #fb725f;
}

.message {
  text-align: center;
  margin: 36px 0 24px;
  font-size: 1.1rem;
}

.form {
  margin-bottom: 24px;
  display: flex;
  column-gap: 48px;
  justify-content: center;
}
</style>

<script>
/* eslint-disable */
import { request } from '@/services'
import { DB_ROUTES } from '../../constants'
import { BIcon, BIconTrash } from 'bootstrap-vue'
import { toast } from '../../utils';
export default {
  props: ['employeeId'],
  components: {
    BIcon,
    BIconTrash
  },
  data() {
    return {
      equipments: [],
      allEquipments: [], // TODO: workaround to get the equipment's name
      equipmentToRemove: null
    }
  },
  computed: {
    isReadOnly () {
      return this.$store.getters.isReadOnly
    },
    isSuperAdmin () {
      return this.$store.getters.isSuperAdmin
    }
  },
  watch: {
    employeeId (newId) {
      this.fetchEquipments(newId)
    }
  },
  created() {
    // TODO: this is a workaround in order to get the equipment name. It might not work for manager role.
    // It would be better if we receive the name in route GET_EQUIPMENTS_BY_EMPLOYEE
    request.get(
      DB_ROUTES.GET_ALL_EQUIPMENTS,
      response => this.allEquipments = response.data
    )
  },
  methods: {
    fetchEquipments(id) {
      request.get(
        DB_ROUTES.GET_EQUIPMENTS_BY_EMPLOYEE(id),
        (response) => {
          if (response.status === 200) {
            this.equipments = response.data.map(item => {
              return {
                id: item.equipmentId,
                name: this.getEquipmentName(item.equipmentId) // TODO: make route GET_EQUIPMENTS_BY_EMPLOYEE return the name of each equipment
              }
            })
          } else {
            this.equipments = []
          }
        },
        error => console.log(error)
      )
    },
    confirmRemove(equipment) {
      if (this.isReadOnly) return
      this.equipmentToRemove = equipment
    },
    removeEquipment() {
      if (this.isReadOnly) return
      request.delete(
        DB_ROUTES.DELETE_EQUIPMENT_FROM_EMPLOYEE(this.employeeId, this.equipmentToRemove.id),
        response => {
          if (response.status === 200) {
            toast(this, 'success', 'Equipamento removido', 'Permissão ao equipamento removida com sucesso.')
            this.equipments = this.equipments.filter(equip => equip.id !== this.equipmentToRemove.id)
            this.equipmentToRemove = null
          } else {
            toast(this, 'danger', 'Erro na remoção', 'Erro inesperado na remoção do equipamento')
            console.log(response)
          }
        },
        error => {
          toast(this, 'danger', 'Erro na remoção', 'Erro inesperado na remoção do equipamento')
          console.log(error)
        }
      )
    },
    // TODO: this is a workaround. It would be better if we receive 
    // the equipment name in route GET_EQUIPMENTS_BY_EMPLOYEE
    getEquipmentName(id) {
      const equipment = this.allEquipments.find(item => item.id === id)
      return equipment.name
    },
    handleModalClose() {
      this.equipmentToRemove = null
    },
    goToEquipmentsPage() {
      if (!this.isSuperAdmin) return
      this.$router.push('equipamentos')
    }
  }
}
</script>
